export const NOT_SET_VALUE = ""
